export const DEFAULT_PAGE = 1;

export const DEFAULT_PER_PAGE = 10;

export const DEFAULT_PAGE_OPTIONS = [10, 20, 50];

export const MAX_QUERY_PER_PAGE = 999999;
